// extracted by mini-css-extract-plugin
module.exports = {"container":"iWX7f","domainsHeader":"_6hfjX"};